import styled, { css } from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import Box, { BoxProps } from 'components/shared/Box'
import Text from 'components/shared/Text'

interface WrapperProps extends BoxProps {
    isLongTitle?: boolean
}

export const ThankYouInfoBox = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;
    @media ${respondAbove.xl} {
        min-width: 570px;
        min-height: 196px;
        img {
            max-width: 169px;
        }
    }
`

export const Wrapper = styled(Box)<WrapperProps>`
    ${({ isLongTitle }) =>
        isLongTitle &&
        css`
            @media ${respondAbove.xl} {
                min-height: 296px;
            }
        `}
`

export const ThankYouQuestions = styled(Text)`
    @media ${respondAbove.xl} {
        flex: 1;
    }
`

export const ThankYouSocialBox = styled(Box)`
    @media ${respondAbove.xl} {
        flex: 0.5;
    }
`
